export const getColors = (props) => props.theme.colors;
export const getFonts = (props) => props.theme.fonts;
export const getBackgrounds = (props) => props.theme.backgrounds;
export const getTypography = (props) => props.theme.typography;
export const getButtons = (props) => props.theme.buttons;
export const getPalette = (props) => props.theme.palette;
